// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const deviceSelector = createSelector(
    (state): any => state,
    (res: { device: any }) => res.device || {}
);

export const deviceInformationSelector = createSelector(
    deviceSelector,
    res => res.part
);

export const deviceEligibilitySelector = createSelector(
    deviceSelector,
    res => res.eligibilityOptions
);

export const claimsSelector = createSelector(deviceSelector, res => res.claims);

export const deviceWarrantiesSelector = createSelector(
    deviceSelector,
    res => res.warranties
);

export const deviceSymptomSelector = createSelector(
    deviceEligibilitySelector,
    symptom =>
        (symptom || []).filter(
            (symptom: any) => symptom.symptomType.toLowerCase() === 'device'
        )
);

export const devicePartSelector = createSelector(
    deviceEligibilitySelector,
    parts =>
        (parts || []).filter(
            (part: any) => part.symptomType.toLowerCase() === 'part'
        )
);

export const deviceAccessorySelector = createSelector(
    deviceEligibilitySelector,
    parts =>
        (parts || []).filter(
            (part: any) => part.symptomType.toLowerCase() === 'accessory'
        )
);

const serviceRequestSelector = createSelector(
    (state): any => state,
    (res: { serviceRequests: any }) => res.serviceRequests.information
);

export const deviceOrderHistorySelector = createSelector(
    serviceRequestSelector,
    res => res.eligibilityOptions
);

export const fullDeviceEligibilitySelector = createSelector(
    deviceSelector,
    res => res.repairEligibilityCode || ''
);
export const partDeviceEligibilitySelector = createSelector(
    deviceSelector,
    res => res.partEligibilityCode || ''
);
export const accessoryDeviceEligibilitySelector = createSelector(
    deviceSelector,
    res => res.fulfillmentEligibilityCode || ''
);

export const claimDetailSelector = createSelector(
    deviceSelector,
    res => res.claimDetails || []
);

export const orderUpdateAlertSelector = createSelector(
   deviceSelector,
   res => res.showOrderUpdateAlert || false
);